/* eslint-disable react-hooks/exhaustive-deps */

import React, {useContext, useEffect, useMemo, useState} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import moment from 'moment';
import {
  amlScreeningIc,
  eye,
  lookupEmpty,
  backNofill,
} from '../../../assets/images/images';
import {
  DashboardLayout,
  EmptyState,
  Loader,
  PageLimit,
  Pagination,
  PrimaryButton,
  TableLayout,
} from '../../../components';
import {PAGES_URL} from '../../../helpers/constants';
import {AMLScreeningTour} from '../../../components/Tour';
import * as Actions from '../../../store/actions';
import {PageContext, TourContext} from '../../../helpers/context';
import ToggleOngoingMonitoring from '../ToggleOngoingMonitoring';
import BatchAmlModal from './BatchAmlModal';
import BatchAmlResultModal from './BatchAmlResultModal';
import {OverviewCards} from '../../../components/OverviewCards';
import {buildTableCardData} from '../../../helpers/buildTableCardData';
import Breadcrumbs from 'components/BreadCrumbs';
import PageNumber from 'components/PageNumber';

function AmlUserScreeningBatch({
  getBatchAmlHistory,
  getAllApps,
  amlConfigApi,
  auth: {userDetails, updated},
  aml: {loading, configLoading, batchAmlHistory},
  apps: {allApps},
}) {
  const [currentPage, setCurrentPage] = useState('1');
  const [limit, setLimit] = useState(10);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openBatchAml, setOpenBatchAml] = useState(false);
  const [amlResultModal, setAmlResultModal] = useState(false);
  const [selectedHistory, setSelectedHistory] = useState(null);
  const [downloaded, setDownloaded] = useState(false);
  const [, setUploadPercentage] = useState(0);
  const {setPageName} = useContext(PageContext);
  useEffect(() => {
    setPageName('amllookup');
  }, [setPageName]);

  const appIds =
    useMemo(
      () => allApps?.apps && allApps?.apps?.map(app => app?._id)?.toString(),
      [allApps],
    ) || localStorage.getItem('appIds');

  const calculateUploadProgress = data => {
    let totalRecords = 0;
    let processedRecords = 0;

    data.forEach(item => {
      totalRecords += item.total_records;
      processedRecords += item.processed_records;
    });

    return totalRecords !== 0 ? (processedRecords / totalRecords) * 100 : 0;
  };

  useEffect(() => {
    if (batchAmlHistory && batchAmlHistory.records) {
      const percentage = calculateUploadProgress(batchAmlHistory.records);
      setUploadPercentage(percentage);
    }

    const interval = setInterval(() => {
      if (batchAmlHistory && batchAmlHistory.records) {
        const percentage = calculateUploadProgress(batchAmlHistory.records);
        if (percentage !== 100) {
          getBatchAmlHistory({
            page: currentPage,
            company_id: userDetails?.company?.id,
            limit,
            appIds,
            includeAmlIndividual: true,
          });
          setUploadPercentage(percentage);
        } else {
          clearInterval(interval);
        }
      }
    }, 60000);

    return () => clearInterval(interval);
  }, [
    appIds,
    batchAmlHistory,
    currentPage,
    getBatchAmlHistory,
    limit,
    userDetails?.company?.id,
  ]);

  useEffect(() => {
    getAllApps({});
    appIds &&
      userDetails?.company?.id &&
      getBatchAmlHistory({
        page: currentPage,
        company_id: userDetails?.company?.id,
        limit,
        appIds,
        includeAmlIndividual: true,
      });
  }, [
    getBatchAmlHistory,
    userDetails?.company?.id,
    amlConfigApi,
    limit,
    currentPage,
    getAllApps,
    updated,
    Boolean(appIds?.split(',')?.length),
  ]);

  // to populate with latest data
  useEffect(() => {
    if (selectedHistory && batchAmlHistory && batchAmlHistory.records) {
      const newSelectedHistory = batchAmlHistory.records.find(
        item => item.id === selectedHistory.id,
      );
      if (newSelectedHistory) {
        setSelectedHistory(newSelectedHistory);
      }
    }
  }, [batchAmlHistory, selectedHistory]);

  const calculateStatus = history => {
    const totalRecords = history?.total_records || 0;
    const processedRecords = history?.processed_records || 0;

    const percentage =
      totalRecords !== 0 ? (processedRecords / totalRecords) * 100 : 0;

    if (percentage === 100) {
      return 'COMPLETED';
    } else {
      return 'PROCESSING';
    }
  };

  const pageClick = selected => {
    setCurrentPage(selected);
  };

  const DATA = batchAmlHistory?.records;

  const {tourState, updateTourState} = useContext(TourContext);

  const {performBatchIndividualLookup: canPerformAndViewAML} = useMemo(
    () => userDetails?.permissions?.amlScreeningPermissions || {},
    [],
  );
  // hack to fetch back the original data after downloading
  const fetchDataWithoutDownload = () => {
    getBatchAmlHistory({
      page: currentPage,
      company_id: userDetails?.company?.id,
      limit,
      appIds,
      includeAmlIndividual: true,
    });
  };

  const handleDownloadAndFetch = () => {
    setDownloaded(true);
    getBatchAmlHistory({
      page: currentPage,
      company_id: userDetails?.company?.id,
      limit,
      appIds,
      includeAmlIndividual: true,
      download: true,
    });
  };

  useEffect(() => {
    if (downloaded) {
      fetchDataWithoutDownload();
      setDownloaded(false);
    }
  }, [downloaded]);
  // end of hack

  const tableCardData = buildTableCardData({
    count: batchAmlHistory?.totalRecords,
  });

  return (
    <DashboardLayout
      breadCrumbs={
        <p className="text-tiny font-normal text-deepBlue">AML Screening</p>
      }
    >
      {tourState?.aml_screening_tour ? (
        <AMLScreeningTour
          updateTourState={updateTourState}
          DATA={DATA}
          loading={loading}
        />
      ) : null}
      {/*<OngoingMonitoringConfig setOpen={setOnGoing} open={onGoing} />*/}
      <ToggleOngoingMonitoring
        loading={configLoading}
        setOpen={setOpenConfirm}
        open={openConfirm}
      />

      <BatchAmlResultModal
        open={amlResultModal}
        setOpen={setAmlResultModal}
        selectedHistory={selectedHistory}
      />

      <BatchAmlModal open={openBatchAml} setOpen={setOpenBatchAml} />

      <div className="flex items-center min-h-[52px] py-2 flex-wrap gap-3 justify-between mr-[-24px] ml-[-32px] px-8 border border-transparent border-b-[#E4E4E6]">
        <Breadcrumbs
          items={[
            {
              label: 'Batch User Screening',
              path: PAGES_URL.AML_USER_SCREENING,
            },
            {label: 'History'},
          ]}
        />
        {/* <div className="flex flex-wrap items-center gap-4 sm:flex-nowrap">
          <PrimaryButton
            buttonText="Perform AML Lookup"
            xPadding="px-4"
            className="hidden sm:flex"
            onClick={() => {
              setOpenBatchAml(true);
            }}
            disabled={!canPerformAndViewAML}
            title={
              !canPerformAndViewAML
                ? 'You do not have permission to do this'
                : ''
            }
          />
          <PrimaryButton
            buttonText="Export"
            xPadding="px-4"
            className="hidden sm:flex"
            onClick={() => {
              handleDownloadAndFetch();
            }}
          />
          <div className="fixed bottom-0 left-0 right-0 z-10 px-4 py-2 overflow-x-hidden sm:hidden bg-white80">
            <PrimaryButton
              buttonText="Perform AML Lookup"
              xPadding="p-4"
              className="w-full bottom-2"
              onClick={() => {
                setOpenBatchAml(true);
              }}
            />
          </div>
        </div> */}
      </div>

      <OverviewCards
        cardData={tableCardData}
        overviewLoading={loading}
        className={`grid grid-cols-2 md:grid-cols-3 xl:grid-cols-1 gap-2 lg:gap-4 flex-wrap my-6`}
      />

      <TableLayout negativeMargins>
        <thead className="font-semibold uppercase">
          <tr className="bg-white80">
            <th className="pl-4 sm:pl-6 xl:pl-8 h-11 font-medium text-left text-small text-[#5C688E] whitespace-nowrap">
              name
            </th>
            <th className="pl-0 font-medium text-left h-11 text-small text-[#5C688E] whitespace-nowrap">
              AML Status
            </th>
            <th className="pl-0 font-medium text-left h-11 text-small text-[#5C688E] whitespace-nowrap">
              Type
            </th>
            <th className="pl-0 font-medium text-left h-11 text-small text-[#5C688E] whitespace-nowrap">
              Date created
            </th>{' '}
            <th className="pl-0 font-medium text-left h-11 text-small text-[#5C688E] whitespace-nowrap">
              Entity type
            </th>
            <th className="w-[18.69%]" />
          </tr>
        </thead>

        <tbody>
          <tr>
            <td colSpan={8}>
              {loading ? (
                <Loader height={45} />
              ) : !loading && DATA?.length === 0 ? (
                <EmptyState
                  height={45}
                  noBtn
                  className="w-full"
                  src={lookupEmpty}
                  body="Perform multiple identity lookup with ease."
                  maxWidth="max-w-[500px]"
                  customBtn={
                    <div className="flex gap-6 mt-2 w-full justify-center">
                      <PrimaryButton
                        buttonText="Perform AML Lookup"
                        onClick={() => {
                          setOpenBatchAml(true);
                        }}
                      />
                    </div>
                  }
                />
              ) : null}
            </td>
          </tr>
        </tbody>

        <tbody className="text-sm bg-white">
          {!loading &&
            DATA?.map((history, i = 0) => (
              <tr
                className={`border-[0.5px] border-[#E4E3EC] ${
                  history?.aml_entity_lookup_id &&
                  history?.status === 'available'
                    ? 'cursor-pointer'
                    : history?.status === 'not_availbale'
                    ? 'cursor-pointer'
                    : 'cursor-default'
                }`}
                key={i}
              >
                <td
                  className="p-4 pl-4 sm:pl-6 xl:pl-8  text-body whitespace-nowrap"
                  onClick={() => {
                    setSelectedHistory(history);
                    setAmlResultModal(true);
                  }}
                >
                  {history?.name || ''}
                </td>
                <td
                  className="p-4 pl-0  text-body whitespace-nowrap"
                  onClick={() => {
                    setSelectedHistory(history);
                    setAmlResultModal(true);
                  }}
                >
                  <div
                    className={`flex items-center gap-2 uppercase py-1 px-2 text-xs ${
                      calculateStatus(history) === 'COMPLETED'
                        ? 'text-success  bg-statusBg-200'
                        : 'text-brandBlue50  bg-brandBlue40'
                    } font-medium  rounded-full w-fit`}
                  >
                    {calculateStatus(history)}
                  </div>
                </td>
                <td
                  className="min-w-[100px]"
                  onClick={() => {
                    setSelectedHistory(history);
                    setAmlResultModal(true);
                  }}
                >
                  <p className="py-1 px-2 text-xs font-medium w-fit uppercase rounded-full text-success bg-statusBg-200">
                    no-code
                  </p>
                </td>

                <td
                  className="p-4 pl-0  text-body whitespace-nowrap"
                  onClick={() => {
                    setSelectedHistory(history);
                    setAmlResultModal(true);
                  }}
                >
                  {moment(history?.date_created).format(
                    'Do, MMM YYYY, hh:mm a',
                  )}
                </td>

                <td
                  className="min-w-[100px]"
                  onClick={() => {
                    setSelectedHistory(history);
                    setAmlResultModal(true);
                  }}
                >
                  <p
                    className={`py-1 px-2 text-xs font-medium w-fit uppercase rounded-full ${
                      history?.entity_type?.toLowerCase() === 'business'
                        ? 'text-brandBlue50  bg-brandBlue40'
                        : 'text-danger  bg-statusBg-500'
                    }`}
                  >
                    {history?.entity_type || 'Individual'}
                  </p>
                </td>

                <td
                  className="p-4 pl-0"
                  onClick={() => {
                    setSelectedHistory(history);
                    setAmlResultModal(true);
                  }}
                >
                  <button
                    className={
                      history?.aml_entity_lookup_id &&
                      history?.status === 'not_available'
                        ? 'cursor-pointer'
                        : history?.status === 'not_availbale'
                        ? 'cursor-pointer'
                        : 'cursor-default'
                    }
                    title={
                      !canPerformAndViewAML
                        ? 'You do not have permission to view'
                        : 'View'
                    }
                    onClick={() => {
                      setSelectedHistory(history);
                      setAmlResultModal(true);
                    }}
                    disabled={!canPerformAndViewAML}
                  >
                    <img src={eye} alt="" width={16} height={16} />
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </TableLayout>

      {!loading && batchAmlHistory?.totalRecords > 0 && (
        <div className="flex flex-wrap items-center justify-between gap-4 sm:gap-0 bg-white80 mx-[-32px] px-8 py-[18px] border-[0.5px] border-y-[#E4E3EC] border-transparent">
          <PageNumber
            currentPage={+currentPage}
            limit={limit}
            totalCount={batchAmlHistory?.totalRecords}
          />

          <div className="flex items-center gap-5">
            <PageLimit
              onLimitChange={setLimit}
              total={batchAmlHistory?.totalRecords}
              length={batchAmlHistory?.records?.length}
              limit={limit}
            />

            <Pagination
              total={
                batchAmlHistory &&
                Math.ceil(batchAmlHistory?.totalRecords / limit)
              }
              current={+currentPage}
              onPageChange={activePage => {
                localStorage.setItem('page', String(activePage));
                pageClick(activePage);
              }}
            />
          </div>
        </div>
      )}
    </DashboardLayout>
  );
}

export default connect(state => state, Actions)(AmlUserScreeningBatch);
